import { render, staticRenderFns } from "./workshop-proposals.vue?vue&type=template&id=64f0d7a8&scoped=true"
import script from "./workshop-proposals.vue?vue&type=script&lang=js"
export * from "./workshop-proposals.vue?vue&type=script&lang=js"
import style0 from "./workshop-proposals.vue?vue&type=style&index=0&id=64f0d7a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f0d7a8",
  null
  
)

export default component.exports